import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material'
import { DialogProps } from '@mui/material/Dialog'
import { LocalHospital } from '@mui/icons-material'
import { inject } from 'mobx-react'
import React from 'react'
import ResponsiveAppBar from '../common/ResponsiveAppBar'
import { IProvider } from '../Definitions'
import EditProvider from '../providers/EditProvider'
import { IStores } from '../Stores'

interface IProviderEditDialogProps extends DialogProps {
  close?: () => void
  isOpen?: boolean
  selectedProvider?: IProvider
  setSelectedProvider?: (provider?: IProvider) => void
}

class ProviderEditDialog extends React.Component<IProviderEditDialogProps> {
  private close = () => {
    this.props.close!()
  }

  public render() {
    const { selectedProvider } = this.props
    const id = selectedProvider ? selectedProvider.id : undefined
    const providerMatch = {
      isExact: true,
      params: {
        providerId: id,
      },
      path: '',
      url: '',
    }

    return (
      <Dialog open={this.props.isOpen!} maxWidth="lg" fullWidth>
        <DialogTitle sx={{ padding: 0 }}>
          <ResponsiveAppBar
            title="Provider Details"
            pageIcon={<LocalHospital />}
            isModal={true}
          />
        </DialogTitle>
        <DialogContent>
          <EditProvider
            location={{
              pathname: '/',
              search: '',
              hash: '',
              state: null,
              key: 'default',
            }}
            match={providerMatch}
            isModal={true}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={this.close} data-cy="close">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    )
  }
}

const InjectedProviderEditDialog = inject<
  IStores,
  IProviderEditDialogProps,
  Partial<IProviderEditDialogProps>,
  any
>((stores: IStores) => ({
  close: stores.schedules.closeProviderEditDialog,
  isOpen: stores.schedules.isProviderEditDialogOpen,
  selectedProvider: stores.providers.selectedProvider,
  setSelectedProvider: stores.providers.setSelectedProvider,
}))(ProviderEditDialog)

export default InjectedProviderEditDialog
